import { render, staticRenderFns } from "./ProcessWizardSidebar.vue?vue&type=template&id=682f583f&scoped=true"
import script from "./ProcessWizardSidebar.vue?vue&type=script&lang=ts"
export * from "./ProcessWizardSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ProcessWizardSidebar.vue?vue&type=style&index=0&id=682f583f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f583f",
  null
  
)

export default component.exports